module.exports = __webpack_public_path__ + "img/newsdetails4.acefa700.png";